import React from "react"
import Container from "react-bootstrap/Container";
import Img from "gatsby-image";
import {graphql, useStaticQuery} from "gatsby"

export default () => {
    const data = useStaticQuery(graphql`
    query {
    me: file(relativePath: { eq: "me.png" }) {
      childImageSharp {
        fluid(maxWidth: 1000) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
  `)
    return (
        <Container as="section" id={"about"}>
            <h3 className={"section-title"} style={{textAlign: `right`}}>About me</h3>
            <Container className="separator my-0">
                <div className="row my-5">
                    <div className="col d-flex flex-column justify-content-center px-2">

                        <p>I am an unconventional predoc researcher at Universitat de Barcelona. I’m more interested in
                            creating insight into the mechanics (and dynamics) of Neural Networks, rather than achieving
                            0.0001% more accuracy. Hyperparameter tuning nor dataset + model articles are <i>not</i> my
                            cup
                            of tea.

                        </p>
                        <p>
                            Currently, I’m working on training neural networks with minimum width (in terms of units per
                            layer), and figuring out how to train with initial parameters set to zero (zero
                            initialization). I’m also interested in the Lottery Ticket Hypothesis and NAS (Neural
                            Network
                            Search).
                        </p>
                    </div>
                    <div className="col-sm-3 col-md-4">
                        <Img fluid={data.me.childImageSharp.fluid}/>
                    </div>
                </div>
            </Container>

        </Container>
    )
}

